/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of aligned sequence residues
 * @export
 * @interface SequenceAlign
 */
export interface SequenceAlign {
    /**
     * Corresponds to id in Sequence
     * @type {number}
     * @memberof SequenceAlign
     */
    id: number;
    /**
     * Aligned sequence letters (containing spaces)
     * @type {string}
     * @memberof SequenceAlign
     */
    residues: string;
}

/**
 * Check if a given object implements the SequenceAlign interface.
 */
export function instanceOfSequenceAlign(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "residues" in value;

    return isInstance;
}

export function SequenceAlignFromJSON(json: any): SequenceAlign {
    return SequenceAlignFromJSONTyped(json, false);
}

export function SequenceAlignFromJSONTyped(json: any, ignoreDiscriminator: boolean): SequenceAlign {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'residues': json['residues'],
    };
}

export function SequenceAlignToJSON(value?: SequenceAlign | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'residues': value.residues,
    };
}

